import { useQuery } from "@apollo/client";
import { GET_MARKET_OVERVIEW } from "../graphql/market-dashboard";

export const useMarketOverview = (pollingInterval = 60000) => {
  const { data, loading, error } = useQuery(GET_MARKET_OVERVIEW, {
    pollInterval: pollingInterval,
  });

  return {
    marketOverview: data?.marketOverview,
    loading,
    error,
  };
};
